var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FCE9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14C18.49 14 14 18.49 14 24C14 29.51 18.49 34 24 34C29.51 34 34 29.51 34 24C34 18.49 29.51 14 24 14ZM28.78 21.7L23.11 27.37C22.97 27.51 22.78 27.59 22.58 27.59C22.38 27.59 22.19 27.51 22.05 27.37L19.22 24.54C18.93 24.25 18.93 23.77 19.22 23.48C19.51 23.19 19.99 23.19 20.28 23.48L22.58 25.78L27.72 20.64C28.01 20.35 28.49 20.35 28.78 20.64C29.07 20.93 29.07 21.4 28.78 21.7Z",
    fill: "#CD6422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIconOrange);
export default __webpack_public_path__ + "static/media/yesIconOrange.2f294e56bdecc2ad036f1d0684a3fcd0.svg";
export { ForwardRef as ReactComponent };